<template>
  <modal-form
    :show="showForm"
    v-on:update:show="showForm=$event"
    :title="formTitle"
    v-on:saveData="saveData"
    :readonly="readOnly"
  >
    <code-list-form
      v-if="codeListKey"
      :field-key="codeListKey"
      :read-only="readOnly"
      :id="id"
      v-model="item"
    ></code-list-form>
  </modal-form>
</template>

<script>
  import ModalForm from '@/components/ModalForm'
  import CodeListForm from '@/views/code-list/CodeListForm'
  import consts from '@/components/codelist/defines/consts'
  import CodeListsService from '@/services/code-list'

  export default {
    name: 'EmbededCodeListEditor',
    components: { CodeListForm, ModalForm },
    props: {
      codeListKey: {
        default: undefined,
      },
    },
    data () {
      return {
        showForm: false,
        item: {},
        readOnly: false,
      }
    },
    computed: {
      title () {
        return consts.codeLists[this.codeListKey].title
      },
      addTitle () {
        return 'Add ' + this.title
      },
      editTitle () {
        return 'Edit ' + this.title
      },
      formTitle () {
        if (this.readOnly) {
          return 'Details ' + this.title
        }
        if (this.item.id) {
          return this.editTitle
        }
        return this.addTitle
      },
      id () {
        return this.item.id
      },
    },
    methods: {
      saveData () {
        if (this.item.id) {
          // save edited value
          const ns = new CodeListsService(this.codeListKey)
          ns.put(this.item.id, this.item).then((response) => {
            this.showForm = false
            this.$store.commit('codeList/clearKeyCache', this.codeListKey)
            this.$emit('updated', this.item.id)
          })
        } else {
          // add new value
          const ns = new CodeListsService(this.codeListKey)
          ns.add(this.item).then((response) => {
            this.showForm = false
            this.$store.commit('codeList/clearKeyCache', this.codeListKey)
            this.$emit('updated', response.data.data.id)
          })
        }
      },
      add () {
        this.item = {}
        this.readOnly = false
        this.showForm = true
      },
      edit (itemId) {
        const ns = new CodeListsService(this.codeListKey)
        ns.get(itemId).then((response) => {
          this.readOnly = false
          this.item = response.data.data
          this.showForm = true
        })
      },
      details (itemId) {
        const ns = new CodeListsService(this.codeListKey)
        ns.get(itemId).then((response) => {
          this.readOnly = true
          this.item = response.data.data
          this.showForm = true
        })
      },
    },
  }
</script>

<style scoped>

</style>
